import { render, staticRenderFns } from "./actualTab.vue?vue&type=template&id=3bdd5860&scoped=true&"
import script from "./actualTab.vue?vue&type=script&lang=js&"
export * from "./actualTab.vue?vue&type=script&lang=js&"
import style0 from "./actualTab.vue?vue&type=style&index=0&id=3bdd5860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdd5860",
  null
  
)

export default component.exports